import React, {PureComponent} from 'react';
import i18n from '../services/i18n';

class ReactTableSelectFilter extends PureComponent {
  render() {
    const {onChange, filter, options, width} = this.props;
    return (
      <select
        style={{width: width || '100%', float: 'right'}}
        value={filter ? filter.value : i18n.t('all')}
        onChange={event => onChange(event.target.value)}
      >
        {options.map((option, index) => (
          <option key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
    );
  }
}

export default ReactTableSelectFilter;
